export default __webpack_public_path__ + "_/images/beer/st_patrick/beer-liquid-068f398f47395d61fa92a6fced4e568a87c570147c4b1140ff7bc6c6cc573763.png";